var _path, _g, _rect, _path2, _rect2, _path3, _mask, _path4, _path5, _path6, _g2, _g3, _g4, _g5, _g6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAiText = function SvgAiText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 547,
    height: 489,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D6E5F2",
    strokeDasharray: "4.24 4.24",
    strokeLinejoin: "round",
    strokeWidth: 2.121,
    d: "M69.815 65.012v62.042h177.111M50.725 349.77v-51.967h169.687M383.736 340.225h120.903v73.177M481.307 119.631v97.57h-73.178"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai_text_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.953,
    height: 424.219,
    x: 126.023,
    y: 22.061,
    fill: "#fff",
    rx: 8.484
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 253.471,
    height: 92.268,
    x: 147.53,
    y: 45.53,
    fill: "#fff",
    stroke: "#EDEDED",
    strokeWidth: 1.061,
    rx: 7.954
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M159.727 63.03a5.3 5.3 0 0 1 5.302-5.303h218.473a5.303 5.303 0 1 1 0 10.605H165.029a5.3 5.3 0 0 1-5.302-5.303M159.727 82.118a5.303 5.303 0 0 1 5.302-5.303h78.481a5.303 5.303 0 0 1 0 10.606h-78.481a5.3 5.3 0 0 1-5.302-5.303M159.727 120.299a5.3 5.3 0 0 1 5.302-5.303h127.266a5.303 5.303 0 1 1 0 10.606H165.029a5.303 5.303 0 0 1-5.302-5.303M306.082 120.299a5.303 5.303 0 0 1 5.303-5.303h72.117a5.303 5.303 0 0 1 0 10.606h-72.117a5.303 5.303 0 0 1-5.303-5.303M159.727 101.209a5.303 5.303 0 0 1 5.302-5.303h102.873a5.303 5.303 0 1 1 0 10.606H165.029a5.3 5.3 0 0 1-5.302-5.303M281.689 101.209a5.303 5.303 0 0 1 5.303-5.303h14.848a5.303 5.303 0 0 1 0 10.606h-14.848a5.303 5.303 0 0 1-5.303-5.303M315.627 101.209a5.303 5.303 0 0 1 5.303-5.303h62.572a5.303 5.303 0 0 1 0 10.606H320.93a5.303 5.303 0 0 1-5.303-5.303M257.297 82.118a5.303 5.303 0 0 1 5.303-5.303h120.902a5.303 5.303 0 1 1 0 10.606H262.6a5.303 5.303 0 0 1-5.303-5.303"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 253.471,
    height: 92.268,
    x: 147.644,
    y: 266.53,
    fill: "#fff",
    stroke: "#EDEDED",
    strokeWidth: 1.061,
    rx: 7.954
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M159.84 284.03a5.3 5.3 0 0 1 5.303-5.302h218.472a5.302 5.302 0 1 1 0 10.605H165.143a5.303 5.303 0 0 1-5.303-5.303M159.84 303.118a5.303 5.303 0 0 1 5.303-5.303h78.48a5.303 5.303 0 0 1 0 10.606h-78.48a5.303 5.303 0 0 1-5.303-5.303M159.84 341.299a5.303 5.303 0 0 1 5.303-5.303h127.265a5.303 5.303 0 1 1 0 10.606H165.143a5.303 5.303 0 0 1-5.303-5.303M306.195 341.299a5.303 5.303 0 0 1 5.303-5.303h72.117a5.303 5.303 0 1 1 0 10.606h-72.117a5.303 5.303 0 0 1-5.303-5.303M159.84 322.208a5.303 5.303 0 0 1 5.303-5.303h102.873a5.302 5.302 0 0 1 0 10.606H165.143a5.303 5.303 0 0 1-5.303-5.303M281.803 322.208a5.303 5.303 0 0 1 5.303-5.303h14.847a5.303 5.303 0 1 1 0 10.606h-14.847a5.303 5.303 0 0 1-5.303-5.303M315.74 322.208a5.303 5.303 0 0 1 5.303-5.303h62.572a5.303 5.303 0 1 1 0 10.606h-62.572a5.303 5.303 0 0 1-5.303-5.303M257.41 303.118a5.303 5.303 0 0 1 5.303-5.303h120.902a5.303 5.303 0 0 1 0 10.606H262.713a5.303 5.303 0 0 1-5.303-5.303"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ai_text_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147 384.484a8.485 8.485 0 0 1 8.484-8.484h238.032a8.485 8.485 0 0 1 8.484 8.484V446H147z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147 384.484a8.485 8.485 0 0 1 8.484-8.484h238.032a8.485 8.485 0 0 1 8.484 8.484V446H147z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M145.939 384.484c0-5.271 4.274-9.545 9.545-9.545h238.032c5.271 0 9.545 4.274 9.545 9.545h-2.122c0-4.1-3.323-7.423-7.423-7.423H155.484a7.423 7.423 0 0 0-7.423 7.423zM402 446H147zm-256.061 0v-61.516c0-5.271 4.274-9.545 9.545-9.545v2.122a7.423 7.423 0 0 0-7.423 7.423V446zm247.577-71.061c5.271 0 9.545 4.274 9.545 9.545V446h-2.122v-61.516c0-4.1-3.323-7.423-7.423-7.423z",
    mask: "url(#ai_text_svg__b)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M159.727 394.043a5.3 5.3 0 0 1 5.302-5.303h218.473a5.303 5.303 0 1 1 0 10.606H165.029a5.3 5.3 0 0 1-5.302-5.303M159.727 413.132a5.3 5.3 0 0 1 5.302-5.303h78.481a5.302 5.302 0 0 1 0 10.606h-78.481a5.303 5.303 0 0 1-5.302-5.303M159.727 432.222a5.3 5.3 0 0 1 5.302-5.303h102.873a5.303 5.303 0 1 1 0 10.605H165.029a5.3 5.3 0 0 1-5.302-5.302M281.689 432.222a5.303 5.303 0 0 1 5.303-5.303h14.848a5.303 5.303 0 0 1 0 10.605h-14.848a5.303 5.303 0 0 1-5.303-5.302M315.627 432.222a5.303 5.303 0 0 1 5.303-5.303h62.572a5.303 5.303 0 1 1 0 10.605H320.93a5.3 5.3 0 0 1-5.303-5.302M257.297 413.132a5.303 5.303 0 0 1 5.303-5.303h120.902a5.303 5.303 0 1 1 0 10.606H262.6a5.303 5.303 0 0 1-5.303-5.303"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai_text_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 334.121,
    height: 121.625,
    x: 65.211,
    y: 152.148,
    fill: "#fff",
    stroke: "#51C394",
    strokeWidth: 1.398,
    rx: 10.485
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2FFEA",
    d: "M81.288 175.215a6.99 6.99 0 0 1 6.99-6.99h287.987a6.99 6.99 0 1 1 0 13.979H88.278a6.99 6.99 0 0 1-6.99-6.989M81.288 200.379a6.99 6.99 0 0 1 6.99-6.99H191.73a6.99 6.99 0 1 1 0 13.98H88.278a6.99 6.99 0 0 1-6.99-6.99M81.288 250.707a6.99 6.99 0 0 1 6.99-6.99h167.759a6.99 6.99 0 1 1 0 13.98H88.278a6.99 6.99 0 0 1-6.99-6.99M274.211 250.707a6.99 6.99 0 0 1 6.99-6.99h95.064a6.99 6.99 0 1 1 0 13.98h-95.064a6.99 6.99 0 0 1-6.99-6.99M81.288 225.542a6.99 6.99 0 0 1 6.99-6.99h135.605a6.99 6.99 0 1 1 0 13.98H88.278a6.99 6.99 0 0 1-6.99-6.99M242.057 225.542a6.99 6.99 0 0 1 6.99-6.99h19.572a6.99 6.99 0 0 1 0 13.98h-19.572a6.99 6.99 0 0 1-6.99-6.99M286.793 225.542a6.99 6.99 0 0 1 6.99-6.989h82.482a6.99 6.99 0 1 1 0 13.979h-82.482a6.99 6.99 0 0 1-6.99-6.99M209.903 200.379a6.99 6.99 0 0 1 6.99-6.99h159.372a6.99 6.99 0 1 1 0 13.98H216.893a6.99 6.99 0 0 1-6.99-6.99"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai_text_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.906,
    height: 50.906,
    x: 43.301,
    y: 39.029,
    fill: "#fff",
    rx: 8.484
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.967,
    height: 51.967,
    x: 42.77,
    y: 38.499,
    stroke: "url(#ai_text_svg__e)",
    strokeWidth: 1.061,
    rx: 9.015
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai_text_svg__f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.906,
    height: 50.906,
    x: 454.793,
    y: 112.206,
    fill: "#fff",
    rx: 8.484
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.846,
    height: 49.846,
    x: 455.323,
    y: 112.736,
    stroke: "url(#ai_text_svg__g)",
    strokeWidth: 1.061,
    rx: 7.954
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai_text_svg__h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.633,
    height: 50.906,
    x: 17.848,
    y: 329.619,
    fill: "#fff",
    rx: 8.484
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.572,
    height: 49.846,
    x: 18.378,
    y: 330.149,
    stroke: "url(#ai_text_svg__i)",
    strokeWidth: 1.061,
    rx: 7.954
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai_text_svg__j)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.906,
    height: 50.906,
    x: 478.125,
    y: 395.373,
    fill: "#fff",
    rx: 8.484
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.846,
    height: 49.846,
    x: 478.655,
    y: 395.903,
    stroke: "url(#ai_text_svg__k)",
    strokeWidth: 1.061,
    rx: 7.954
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A2A",
    d: "M497.978 411.225h2.821V425.5h-2.821zm2.015 5.621h3.415v2.312h-3.415zm-11.856 11.433h13.362v2.248h-13.362zm0-4.264h2.821v5.26h-2.821zm2.672-11.539c3.012 0 5.345 2.1 5.345 5.006 0 2.885-2.333 4.985-5.345 4.985s-5.345-2.1-5.345-4.985c0-2.906 2.333-5.006 5.345-5.006m0 2.461c-1.442 0-2.588.933-2.588 2.545 0 1.591 1.146 2.524 2.588 2.524 1.464 0 2.588-.933 2.588-2.524 0-1.612-1.124-2.545-2.588-2.545m15.186-2.715h2.799v8.251h-2.799zm0 7.678h1.59c3.394 0 5.749-.085 8.379-.594l.318 2.249c-2.715.53-5.176.636-8.697.636h-1.59zm12.472-8.675h2.821v11.772h-2.821zm-4.667 1.739h5.367v2.143H513.8zm0 3.394h5.367v2.142H513.8zm.827 6.894c4.158 0 6.724 1.421 6.724 3.818 0 2.418-2.566 3.818-6.724 3.818-4.157 0-6.723-1.4-6.723-3.818 0-2.397 2.566-3.818 6.723-3.818m0 2.184c-2.545 0-3.902.531-3.902 1.634s1.357 1.633 3.902 1.633c2.567 0 3.924-.531 3.924-1.633 0-1.103-1.357-1.634-3.924-1.634M60.927 58.233q1.952 0 2.99.87 1.061.869 1.061 2.396a3.5 3.5 0 0 1-.594 1.973q-.572.87-1.59 1.548-.997.657-2.27 1.124l-.976-2.29q1.06-.36 1.803-.891.765-.53.764-1.4 0-.488-.318-.764t-.955-.276q-.573 0-1.103.191t-.975.488a2.6 2.6 0 0 0-.68.615q-.233.318-.233.573 0 .233.17.424.17.17.764.255l-.573 2.354q-1.612-.17-2.418-.976t-.806-1.866q0-.891.488-1.676a4.65 4.65 0 0 1 1.336-1.4 7 7 0 0 1 1.91-.933 7.2 7.2 0 0 1 2.205-.34m4.242 8.76q0 1.802-1.42 2.927-1.401 1.103-3.84 1.103-1.676 0-3.14-.446a7.9 7.9 0 0 1-2.714-1.527q-1.23-1.06-2.249-2.885-.996-1.845-1.803-4.602l2.652-.743q.87 2.885 1.866 4.603 1.02 1.696 2.27 2.44 1.252.72 2.863.72 1.104 0 1.888-.487.785-.489.785-1.4 0-.721-.51-1.167a3.3 3.3 0 0 0-1.23-.7l2.525-1.124q.89.594 1.463 1.421.594.806.594 1.867M74.89 58.381v2.333h-1.21q-.72.36-1.4.891-.657.51-1.187 1.188-.51.657-.827 1.464a5 5 0 0 0-.297 1.739q0 1.272.382 1.994.381.72.954 1.018a2.6 2.6 0 0 0 1.145.275q.382 0 .743-.063.36-.086.827-.318l1.06 2.1a4.9 4.9 0 0 1-1.378.551 7.7 7.7 0 0 1-1.421.127q-1.57 0-2.737-.636-1.166-.657-1.802-1.909-.615-1.273-.616-3.076 0-1.462.53-2.715a6.7 6.7 0 0 1 1.485-2.184 6.4 6.4 0 0 1 2.291-1.443l-1.357.912q-.34.043-.785.064-.424.021-1.103.021h-2.185v-2.333z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A2A",
    d: "M80.265 61.287q1.95 0 3.097.594 1.166.573 1.675 1.463t.51 1.824q0 1.74-1.104 2.673-1.08.912-3.075 1.23l-.488-.87q1.06.275 2.1.68 1.04.402 2.057.954a19 19 0 0 1 2.036 1.251L85.59 73.06a20 20 0 0 0-2.121-1.336q-1.103-.615-2.355-1.103-1.23-.51-2.588-.891a24 24 0 0 0-2.863-.615l.467-2.227q.742.19 1.442.297.721.105 1.442.106 1.357 0 2.164-.255.806-.276 1.166-.742.382-.467.382-1.103 0-.765-.594-1.23-.572-.468-1.633-.467-.615 0-.997.106-.36.105-.53.34a.9.9 0 0 0-.148.53q0 .105.042.254t.085.255l-2.63.381a4.4 4.4 0 0 1-.297-1.506q0-.763.509-1.336.51-.594 1.463-.912.955-.318 2.27-.318m-2.503 1.209a2.07 2.07 0 0 0-.636-1.21q-.53-.508-1.528-.742l1.612-.933.976.234q1.188.487 1.718 1.081.531.594.615 1.506zm9.29-4.115v2.333H74.474v-2.333zM32.313 363.225v-7.551q0-1.018-.551-1.464-.552-.445-1.697-.445-1.103 0-2.163.339a8.6 8.6 0 0 0-1.803.763v-2.63q.615-.297 1.739-.594 1.125-.318 2.588-.318 1.124 0 2.015.276.912.275 1.315 1.082.89.276 1.273 1.082.402.784.402 2.036v7.424zm-3.478.212q-1.824 0-2.821-.87-.976-.87-.976-2.439 0-1.697 1.21-2.715 1.23-1.018 3.86-1.23l2.715-.213v2.291l-2.355.234q-1.272.126-1.782.509a1.23 1.23 0 0 0-.487 1.018q0 .636.403.954.424.318 1.081.318.255 0 .51-.042.255-.063.466-.127l.276 1.994a5 5 0 0 1-.955.233q-.552.085-1.145.085m4.857-9.524-1.74-1.464q.744-.253 1.168-.636.423-.403.445-.976h2.779q0 .658-.276 1.273-.255.594-.849 1.061-.572.466-1.527.742m7.86 9.587q-1.082 0-2.036-.254a7.5 7.5 0 0 1-1.782-.679l.849-2.312q.466.276 1.124.488.657.212 1.294.212 1.187 0 1.888-.891.7-.912.7-2.715 0-1.697-.7-2.588-.7-.89-2.185-.89-.7 0-1.443.212-.742.19-1.23.488v-2.609a7 7 0 0 1 1.485-.467 8.8 8.8 0 0 1 1.76-.17q1.952 0 3.182.721t1.803 2.079q.573 1.337.573 3.224 0 3.012-1.379 4.582t-3.903 1.569m2.039-13.511q-.997 0-1.57-.297-.572-.297-.806-.742a2 2 0 0 1-.254-.976q0-.36.106-.764a3 3 0 0 1 .318-.784l2.312.296a2 2 0 0 0-.064.319 1 1 0 0 0-.042.275q0 .297.19.467.17.149.595.149h4.56v2.057zm12.378 13.236v-7.551q0-1.018-.552-1.464-.55-.445-1.697-.445-1.102 0-2.163.339a8.6 8.6 0 0 0-1.803.763v-2.63q.615-.297 1.74-.594 1.123-.318 2.587-.318 1.124 0 2.015.276.912.275 1.315 1.082.89.276 1.273 1.082.402.784.403 2.036v7.424zm-3.479.212q-1.824 0-2.821-.87-.975-.87-.976-2.439 0-1.697 1.21-2.715 1.23-1.018 3.86-1.23l2.715-.213v2.291l-2.355.234q-1.272.126-1.781.509a1.23 1.23 0 0 0-.488 1.018q0 .636.403.954.424.318 1.082.318.255 0 .509-.042.255-.063.466-.127l.276 1.994a5 5 0 0 1-.955.233 7.6 7.6 0 0 1-1.145.085m4.857-9.524-1.739-1.464q.742-.253 1.167-.636.423-.403.445-.976H60q0 .658-.276 1.273-.255.594-.848 1.061-.573.466-1.528.742m8.942 9.524q-1.717 0-2.736-.743-1.018-.764-1.464-2.078-.445-1.336-.445-3.055 0-1.845.403-3.054.425-1.23 1.188-1.909a4.2 4.2 0 0 1 1.803-.976 8.6 8.6 0 0 1 2.312-.297q1.908 0 3.054.531 1.146.53 1.654 1.506.53.975.53 2.29v7.573h-3.18v-7.318q0-.998-.489-1.506-.466-.53-1.57-.53-.742 0-1.314.318-.552.296-.87 1.082-.297.784-.297 2.248 0 .996.19 1.76.192.764.616 1.188.445.424 1.188.424.233 0 .445-.021.234-.042.403-.085l.297 2.376q-.34.149-.827.212a6.5 6.5 0 0 1-.89.064m-3.9-13.448v-1.336l2.142-.891h7.572v2.227zm7-1.294v-2.397h2.714v2.397zM471.057 131.898v6.825h-2.796v-6.825zm6.401 0v6.825h-2.796v-6.825zm14.448 5.406v7.447h-2.807v-7.467q0-1.585-.673-2.227-.673-.653-2.341-.653h-5.251v-2.506h5.427q2.041 0 3.273.549 1.243.549 1.802 1.74.57 1.18.57 3.117m-8.068-.362v7.809h-2.796v-7.809z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D6E5F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.061,
    d: "M100.57 52.817h10.606M100.57 69.785h10.606M100.57 61.303h10.606M100.57 78.27h10.606M26.332 52.817h10.606M26.332 69.785h10.606M26.332 61.303h10.606M26.332 78.27h10.606M82.541 21.06v10.605M65.572 21.019v10.605M74.057 21.04v10.606M57.088 21v10.606M13.606 365.679H3M13.606 348.71H3M13.606 357.193H3M13.606 340.226H3M95.268 365.679H84.662M95.268 348.71H84.662M95.268 357.193H84.662M95.268 340.226H84.662M35.877 396.374v-10.606M52.846 396.415v-10.606M44.361 396.393v-10.605M61.33 396.434v-10.606M512.062 125.994h10.606M512.062 142.963h10.606M512.062 134.479h10.606M512.062 151.447h10.606M437.824 125.994h10.606M437.824 142.963h10.606M437.824 134.479h10.606M437.824 151.447h10.606M494.033 94.238v10.605M477.064 94.196v10.606M485.549 94.218v10.605M468.58 94.178v10.605M471.762 431.431h-10.606M471.762 414.462h-10.606M471.762 422.945h-10.606M471.762 405.978h-10.606M546 431.431h-10.605M546 414.462h-10.605M546 422.945h-10.605M546 405.978h-10.605M489.791 463.188v-10.605M506.76 463.229v-10.605M498.275 463.208v-10.606M515.244 463.248v-10.605"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ai_text_svg__a",
    width: 360.586,
    height: 487.852,
    x: 94.207,
    y: 0.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.908
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_6482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1856_6482",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ai_text_svg__c",
    width: 352.487,
    height: 139.992,
    x: 56.027,
    y: 147.207,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.242
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.242
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_6482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1856_6482",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ai_text_svg__d",
    width: 86.965,
    height: 86.965,
    x: 25.271,
    y: 25.242,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.242
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.484
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_6482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1856_6482",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ai_text_svg__f",
    width: 84.844,
    height: 84.844,
    x: 437.824,
    y: 99.48,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.242
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.484
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_6482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1856_6482",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ai_text_svg__h",
    width: 97.57,
    height: 84.844,
    x: 0.879,
    y: 316.893,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.242
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.484
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_6482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1856_6482",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ai_text_svg__j",
    width: 84.844,
    height: 84.844,
    x: 461.156,
    y: 382.646,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.242
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.484
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_6482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1856_6482",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai_text_svg__e",
    x1: 32.165,
    x2: 106.403,
    y1: 27.894,
    y2: 103.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai_text_svg__g",
    x1: 505.699,
    x2: 454.793,
    y1: 109.555,
    y2: 169.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F89C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai_text_svg__i",
    x1: 17.848,
    x2: 83.602,
    y1: 383.707,
    y2: 329.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F89C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50BF91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai_text_svg__k",
    x1: 530.622,
    x2: 478.125,
    y1: 443.098,
    y2: 390.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F89C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50BF91"
  })))));
};
export default SvgAiText;